// import packages
import gql from "graphql-tag"

// export gqls
export const GET_ANNOUNCEMENT_LIST = gql`
  query Announcements($take: Int, $skip: Int, $input: AnnoucementFilterInput) {
    announcements(take: $take, skip: $skip, input: $input) {
      total
      data {
        id
        title
        content
        type
        startTime
        isNotificationAssistant
        creator {
          id
          name
        }
      }
    }
  }
`

export const SUM_ANNOUNCEMENT_LIST = gql`
  query Announcements($input: AnnoucementFilterInput) {
    announcements(take: 0, input: $input) {
      total
    }
  }
`

export const GET_TABLE_FIELDS = gql`
  query AnnouncementFields {
    announcementFields @client {
      name
      title
      order
      show
    }
  }
`

export const GET_ANNOUNCEMENT = gql`
  query Announcement($id: ID!) {
    announcement(id: $id) {
      id
      title
      content
      type
      startTime
      photoUrl
      companies {
        id
      }
      isNotificationAssistant
      creator {
        id
        name
      }
    }
  }
`

export const GET_COMPANIES = gql`
  query Companies($take: Int, $skip: Int) {
    companies(take: $take, skip: $skip) {
      total
      data {
        id
        name
        area
      }
    }
  }
`

export const UPDATE_ANNOUNCEMENT = gql`
  mutation UpdateAnnouncement($id: ID!, $input: AnnouncementUpdateInput!) {
    updateAnnouncement(id: $id, input: $input) {
      id
    }
  }
`

export const CREATE_ANNOUNCEMENT = gql`
  mutation CreateAnnouncement($input: AnnouncementCreateInput!) {
    createAnnouncement(input: $input) {
      id
    }
  }
`

export const DELETE_ANNOUNCEMENT = gql`
  mutation DeleteAnnouncement($id: ID!) {
    deleteAnnouncement(id: $id)
  }
`
